import { css } from 'lit'

const buttonGlobalStyles = css`
  /* Base button styles */
  button {
    height: 36px;
    padding: 8px 16px;
    border: var(--small-border);
    border-radius: var(--kula-button-border-radius);
    background-color: white;
    font-family: var(--primary-font-family);
    font-weight: 300;
    font-size: 16px;
    line-height: 18px;
    letter-spacing: 0.024px;
    font-style: normal;
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
  }

  /* Special button types */
  button.sm-text {
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
  }
  button.md-text {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
  }
  /* Button color variations */
  button.secondary,
  button.primary,
  button.red {
    color: var(--white);
  }

  button.secondary {
    background-color: var(--kula-light-green);
  }

  button.primary {
    background-color: var(--kula-deep-green);
  }

  button.red {
    background-color: var(--red);
  }

  .submitButton {
    display: flex;
    width: var(--LargeButtonWidth, 120px);
    height: var(--LargeButtonHeight, 32px);
    min-width: 80px;
    max-width: 120px;
    padding: 8px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: var(--ButtonBorderRadiusSM, 8px);
    background: var(--DarkBlue, #3b839f);
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    color: var(--White, #f7f7f7);
    text-align: center;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.016px;
  }
  .cancelButton {
    display: flex;
    width: var(--LargeButtonWidth, 120px);
    height: var(--LargeButtonHeight, 32px);
    min-width: 80px;
    max-width: 120px;
    padding: 8px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: var(--ButtonBorderRadiusSM, 8px);
    border: 1px solid var(--DarkBlue, #3b839f);
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    color: var(--DarkBlue, #3b839f);
    text-align: center;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.016px;
  }
  /* Button interactions */
  button:hover {
    opacity: 0.7;
  }

  /* Disabled button styles */
  button:disabled {
    background-color: var(--gray-light, #e5e5e5);
    color: var(--gray, #808080);
    cursor: not-allowed;
    border-color: var(--gray-light, #e5e5e5);
    box-shadow: none;
    opacity: 1;
  }

  button:disabled:hover {
    opacity: 1;
  }
`

export default buttonGlobalStyles
